// extracted by mini-css-extract-plugin
export default {"Container":"GiftPageProducts_Container__+O3D2","Title":"GiftPageProducts_Title__nWiz3"};